import { useCallback, useEffect, useState } from 'react'

import { Avatar, Box, List, ListItem } from '@mui/material'
import ErrorDisplay from '../../components/error/ErrorDisplay'
import { axiosPrivate } from '../../utils/axiosInstance'
import Loading from '../../Loading'

interface Props {
  userids: string[]
}

/**
 * Organisation users list
 * @param {Props} Props props
 * @returns {JSX.Element}
 */
export function UserList({ userids }: Props) {
  const [isLoadingUsers, setLoadingUser] = useState(true)
  const [users, setUsers] = useState<any[]>([])
  const [loadError, setLoadError] = useState(null)

  const getUsers = useCallback(async () => {
    const usersBack: any[] = []
    const promises = []
    for (let index = 0; index < userids.length; index++) {
      const element = userids[index]
      promises.push(axiosPrivate.get(`/mqttapi/v1/admin/org/user/${element}`))
    }
    try {
      const finalResp = await Promise.all(promises)
      finalResp.forEach((resp:any) => {
        usersBack.push(resp.data)
      })
    } catch (error: any) {
      setLoadError(error)
    } finally {
      setLoadingUser(false)
    }

    setUsers(usersBack)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getUsers()
  }, [getUsers])

  if (loadError !== null) {
    return <ErrorDisplay err={loadError} />
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>Users</Box>
      </Box>
      {isLoadingUsers ? (
        <Loading />
      ) : (
        <List>
          {(users || 0).length > 0 &&
            users.map((user: any, idx) => {
              return (
                <ListItem key={idx} sx={{ marginBottom: '10px', borderRadius: '5px' }}>
                  <Avatar sx={{ width: 24, height: 24, marginRight: '5px' }} alt="avatar" src={user.avatar_url} />
                  <span>{user.email}</span>
                </ListItem>
              )
            })}
        </List>
      )}
    </>
  )
}
